<template>
    <b-row class="mt-4 day-detail">
        <b-col cols="12" :id="anchor">
            <b-card no-body>
                <b-card-header
                    class=""
                >
                    {{title}} ({{day.format('DD-MM-YYYY')}}) 
                    <span style="font-size: 1rem;">({{response.total}} PAX) </span> 
                    <span v-if="response.total_without_activity_group > 0" style="font-size: 1rem; color: red;">Atención: {{response.total_without_activity_group}} de {{response.total}} PAX no se les ha podido asignar automáticamente franja horaria</span>
                    
                </b-card-header>
                <b-card-body>
                    <b-row>
                        <b-col v-if="loading" class="text-center">
                            <p class="loading">
                                <i class="fa fa-spinner fa-spin"></i>
                            </p>
                            <p>
                                <span>Cargando...</span>
                            </p>
                        </b-col>
                        <b-col v-else cols="12" class="suprazones">
                            <div class="suprazone" v-for="suprazone in response.suprazones" :key="suprazone.id">
                                <div class="text-center mt-2 mb-3">
                                    <span class="my-3 title">
                                       {{suprazone.name}}
                                    </span>
                                </div>
                                <div>
                                    <b-row>
                                        <b-col cols="6" v-for="activity_group in suprazone.activity_groups" :key="activity_group.id">
                                            <div class="border p-3 text-center my-2 shadow-sm activity-group" :style="activity_group.manage ? '' : 'color: #AAA;'">
                                                <div class="name mb-2">
                                                    {{activity_group.name}}
                                                </div>
                                                <b-row>
                                                    <b-col>
                                                        <div>
                                                            <div>
                                                                <span class="value">
                                                                    {{activity_group.count_activities}}
                                                                </span>
                                                            </div>
                                                            <span>
                                                                Actividades
                                                            </span>
                                                        </div>
                                                    </b-col>  
                                                    <b-col>
                                                        <div>
                                                            <div>
                                                                <span class="value">
                                                                    {{activity_group.total + activity_group.count_pax_no_stop}}
                                                                </span>
                                                            </div>
                                                            <span>
                                                                PAX
                                                            </span>
                                                        </div>
                                                    </b-col>  
                                                    <b-col>
                                                        <div>
                                                            <div>
                                                                <span class="value" :class="activity_group.unassigned_excursion > 0 ? 'text-danger font-weight-bold' : ''">
                                                                    {{activity_group.unassigned_excursion}}
                                                                </span>
                                                            </div>
                                                            <span>
                                                                PAX pendientes <br> (excursión)
                                                            </span>
                                                        </div>
                                                    </b-col>  

                                                    <b-col>
                                                        <div>
                                                            <div>
                                                                <span class="value" :class="activity_group.unassigned_pickup > 0 ? 'text-danger font-weight-bold' : ''">
                                                                    {{activity_group.unassigned_pickup}}
                                                                </span>
                                                            </div>
                                                            <span>
                                                                PAX pendientes <br> (recogidas)
                                                            </span>
                                                        </div>
                                                    </b-col>  
                                                    <b-col>
                                                        <div>
                                                            <div>
                                                                <span class="value" :class="activity_group.count_pax_no_stop > 0 ? 'text-danger font-weight-bold' : ''">
                                                                    {{activity_group.count_pax_no_stop}}
                                                                </span>
                                                            </div>
                                                            <span>
                                                                PAX sin parada
                                                            </span>
                                                        </div>
                                                    </b-col>  
                                                    <b-col>
                                                        <div>
                                                            <div>
                                                                <span class="value">
                                                                    {{activity_group.count_buses}}
                                                                </span>
                                                            </div>
                                                            <span>
                                                                Buses planificados
                                                            </span>
                                                        </div>
                                                    </b-col>  

                                                    

                                                    
                                                </b-row>
                                                <b-row v-if="activity_group.activity_names_list.length > 0">
                                                    <b-col>
                                                        <div class="mt-4 text-left  flex justify-content-end">
                                                            <div class="w-50">
                                                                <span class="font-weight-bold">
                                                                    Actividades con reservas
                                                                </span>
                                                                <div>
                                                                    <ul style="list-style: circle: padding-left: 20px;">
                                                                        <li v-for="activity  in activity_group.activity_names_list" :key="activity.name">{{activity.name}} <span class="text-info">({{activity.count_pax}} pax)</span></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>

                                                <div class="text-right mt-4">
                                                    <b-button
                                                        :variant="activity_group.manage ? 'info' : 'light'"
                                                        class="border py-1 px-3 button"
                                                        @click="navigateManage(day, suprazone, activity_group)"
                                                    >
                                                        <span class="mr-2">Gestionar</span>
                                                        <i class="fa fa-fw fa-wrench"> </i>
                                                    </b-button>
                                                </div>                                              
                                            </div>
                                        </b-col>
                                       
                                    </b-row>
                                    
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="text-right">
                            <span>
                                Actualizado cada {{updateEvery/60}} minutos (+/- {{margin}} segundos). <br>Última actualización: {{lastUpdate.format('DD-MM-YYYY HH:mm:ss')}}
                            </span>
                            <b-button
                                variant="light"
                                class="border py-1 px-3 button"
                                @click="getData(false)"
                            >
                                <span class="mr-2">Actualizar</span>
                                <i class="fa fa-fw fa-cloud-download"> </i>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
/* eslint-disable */
import utils from '../../utils/utils'

export default {
    components: {

    },
    props: {
        title: {
            type: String,
            required: true,
        },
        anchor: {
            type: String,
            required: true,
        },
        day: {
            type: Object,
            required: true,
        },
        noSleep: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    mixins: [utils],
    data() {
        return {
            loading: false,
            response: {},
            lastUpdate: this.$moment(),
            updateEvery: 120, // seconds
            margin: 10, // seconds
            counterInterval: null
        }
    },
    async mounted() {
        if ( this.noSleep ) {
            const sleepTime = Math.random() * (6000 - 500) + 500
            await this.sleep(sleepTime)
        }
        this.getData()
        const minInterval = (this.updateEvery*1000 - this.margin*1000)
        const maxInterval = (this.updateEvery*1000)
        const interval = Math.random() * (maxInterval - minInterval) + minInterval
        this.counterInterval = setInterval(() => {
            this.getData(false)
            console.log('trigger in daydetail')
        },  interval)
        console.log(this.counterInterval + ' daydetail')
        this.$once('hook:beforeDestroy', () => {
            console.log('clearinternval in hook')
            clearInterval(this.counterInterval);
        })
    },
    methods: {
        async getData(loading=true) {
            console.log('trigger in daydetail 22')
            if (loading)
                this.loading = true

            const payload = {
                'day': this.day.format('YYYY-MM-DD')
            }
            const response = await this.$store.dispatch("dashboard/planningDay", payload)
            this.response = response
            this.lastUpdate = this.$moment()
            if (loading)
                this.loading = false
        },
        navigateManage(day, suprazone, activityGroup) {
            let filtersData = {
                suprazone: suprazone.id,
                date: day.format('YYYY-MM-DD'),
                group: activityGroup.id,
            };
            
            this.$store.dispatch("filters/updateFilters", filtersData);
            this.$store.dispatch("layout/setActiveTabAndOption", {tab: 'Excursions', option: 'Activity'})
            this.$store.dispatch("layout/loadData", {reset: false}, {root: true})
            this.$router.push('/app/excursiones/excursiones')
        }
    },
    watch: {
        day: {
            handler: function() {
                this.getData()
            }
        }
    }
}
</script>

<style scoped>
.day-detail .card-header {
    font-size: 1.5rem;
    font-weight: bold;
}
.suprazones .suprazone:not(:first-child) {
    border-top: 1px solid #d6dee5;
    margin-top: 2rem;
    padding-top: 1rem;
}
.suprazone {

}
.suprazone .title {
    font-weight: 700;
    font-size: 1.6rem;
}
.activity-group .name {
    font-size: 1.5em;
    font-weight: bold;
}
.value {
    font-size: 2rem;
}
p.loading {
    font-size: 2rem;
}
</style>